<script>
export default {
    props: {
        finished: Boolean,
        hideReturn: Boolean
    },
    data() {
        console.log('-----', this.hideReturn)
        return {
            v: 0,
            timeout: null,
            hidden: false
        }
    },
    computed: {
        progressStyle() {
            const width = 463 - 6
            return {
                width: (width * this.v) + 'px'
            }
        },
        gifStyle() {
            return {
                marginLeft: (457 * this.v - 50.5) + 'px'
            }
        }
    },
    watch: {
        finished(finished) {
            if (finished) {
                this.end()
            }
        }
    },
    mounted() {
        this.beginProgress()
    },
    methods: {
        beginProgress() {
            this.timeout = window.setTimeout(() => {
                this.v += (1 - this.v) * 0.1
                this.beginProgress()
            }, 1000)
        },
        end() {
            window.clearTimeout(this.timeout)
            this.v = 1
            setTimeout(() => {
                this.hidden = true
            }, 400);
        },
        clickBack() {
            this.$emit('clickBack')
        }
    }
}
</script>

<template>
<div v-if="!hidden" class="LoadingView">
    <div class="backButton" @click="clickBack" v-if="!hideReturn">
        <img src="@/assets/back_btn.svg">
    </div>
    <div class="gifContainer">
        <img :style="gifStyle" width="101px" height="96px" src="@/assets/loading.gif">
    </div>
    <div class="progressBar">
        <div :style="progressStyle"></div>
    </div>
    <p class="loading">LOADING...</p>
</div>
</template>

<style lang="scss" scoped>
.LoadingView {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: #00C1DE;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .gifContainer {
        margin-bottom: 13px;
        width: 457px;

        >img {
            transition: margin-left 0.3s;
        }
    }

    .backButton {
        position: absolute;
        top: 10px;
        left: 10px;

        >img {
            position: absolute;
            top: 10px;
            left: 10px;
            margin: 0px;
            width: 50px;
            height: 50px;
        }
    }

    .backButton:hover {
        cursor: pointer;
    }

    .progressBar {
        width: 463px;
        height: 19px;
        border-radius: 9.5px;
        background-color: #fff;
        display: flex;
        align-items: center;

        >div {
            background: #D6A5AB;
            height: 13px;
            margin-left: 3px;
            border-radius: 9.5px;
            transition: width 0.3s;
        }
    }

    .loading {
        font-size: 18px;
        color: #FFFFFF;
        margin-top: 22px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/visionTrainTrack/LoadingView.vue